import { useTranslation } from 'react-i18next';

import { ContractsListPanel } from '@/pages/contracts/contracts-list-panel';

interface VehicleContractsProps {
	vehicleId: string;
	isActive?: boolean;
}

export const VehicleContracts = ({
	vehicleId,
	isActive = true
}: VehicleContractsProps) => {
	const { t } = useTranslation('vehicles');

	return (
		<ContractsListPanel
			vehicleId={vehicleId}
			isActive={isActive}
			emptyMessage={t('references.noContracts')}
		/>
	);
};
